import { ContentSyncCoordinator, type ContentSyncConfig } from "./content-sync";
import { webinars } from "@/plugins/LocalForagePlugin";
import { webinarsSyncKey } from "@/types/products/product-keys";
import type { ContentfulWebinar, NormalizedContent } from "@tmi/types/entities";
import type { Webinars } from "@tmi/types/api/content-models";

import { createDefaultLogger, LogLevels } from "@/types/console-logger";
const logger = createDefaultLogger( LogLevels.DEBUG );

const config: ContentSyncConfig<Webinars, ContentfulWebinar> = {
    name: 'webinars',
    store: () => webinars,
    syncKey: webinarsSyncKey,
    metaQueryId: '3a47c3a294c1f35253d45a0df29a4fb5',
    contentQueryId: '61a211b1eb8a5b94eb24bbcb79236ce6',
    contentPageSize: 1000,
    metaContentFilter: { fromPublishedDateTimeUTC: '2008-01-01' },
    extractMetaPayload: ( data ) => data.webinarCatalog?.webinars,
    extractContentPayload: ( data ) => data.webinarCatalog?.webinars,
    normalizeItem: normalizeWebinar
};

export class WebinarsSyncCoordinator {
    readonly #inner: ContentSyncCoordinator<Webinars, ContentfulWebinar>;
    constructor() {
        this.#inner = new ContentSyncCoordinator( config );
    }
    patchRepository( authToken: string ): Promise<number> {
        return this.#inner.patchRepository( authToken );
    }
}

export function normalizeWebinar( webinar: ContentfulWebinar ): NormalizedContent | undefined {
    try {
        return {
            contentfulId: webinar.id,
            publishedDate: webinar.publish_dt,
            updatedDate: webinar.publish_at,
            slug: webinar.slug,
            title: webinar.title,
            text: webinar.body,
            isFeatured: webinar.featured,
            registrationUri: webinar.reg_link,
            videoLink: webinar.video,
            webinarDate: webinar.publish_dt,
            editorialAd: webinar.editorial_ad ?? undefined,
            authorId: webinar.author_id,
            adProductId: webinar.ad_product_id,
            categoryIds: webinar.assoc_category_ids ?? [],
            productIds: webinar.assoc_product_ids ?? [],
            sectorIds: webinar.assoc_sector_ids ?? [],
            tickerIds: webinar.assoc_ticker_ids ?? []
        };
    } catch ( e: any ) {
        logger.error( `[ webinars-sync-coordinator ] Failed to normalize webinar '${ webinar.id }':`, e );
        return undefined;
    }
}
